import { Link } from "react-router-dom";
import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, Reveal } from "../components/Kinetic";

const LegalLayout = ({ title, sections, testid }) => (
  <div data-testid={`${testid}-page`}>
    <PageHero overline="Green Horizon Project" titleLines={[title]} testid={testid} />
    <section className="py-20 md:py-28">
      <div className="mx-auto max-w-3xl space-y-12 px-6">
        {sections.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.04}>
            <h2 className="font-display text-xl md:text-2xl font-bold tracking-tight text-graphite">{s.title}</h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-graphite-soft">{s.text}</p>
          </Reveal>
        ))}
        <Reveal>
          <Link
            to="/contact"
            className="inline-block font-mono text-xs uppercase tracking-[0.2em] text-forest underline underline-offset-8 hover:text-graphite transition-colors duration-200"
            data-testid={`${testid}-contact-link`}
          >
            Contact
          </Link>
        </Reveal>
      </div>
    </section>
  </div>
);

export const MentionsLegalesPage = () => {
  const { t } = useLanguage();
  useSEO(`${t("legal.mentionsTitle")} — Green Horizon Project`, t("legal.mentionsMeta"));
  return <LegalLayout title={t("legal.mentionsTitle")} sections={t("legal.mentionsSections")} testid="mentions" />;
};

export const ConfidentialitePage = () => {
  const { t } = useLanguage();
  useSEO(`${t("legal.privacyTitle")} — Green Horizon Project`, t("legal.privacyMeta"));
  return <LegalLayout title={t("legal.privacyTitle")} sections={t("legal.privacySections")} testid="privacy" />;
};

export const NotFoundPage = () => {
  const { t } = useLanguage();
  return (
    <div className="flex min-h-[70vh] items-center pt-16" data-testid="notfound-page">
      <div className="mx-auto max-w-3xl px-6">
        <p className="font-mono text-sm uppercase tracking-[0.25em] text-forest">404</p>
        <h1 className="mt-4 font-display text-4xl md:text-6xl font-light tracking-tight text-graphite">
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-base text-graphite-soft">{t("notFound.text")}</p>
        <Link
          to="/"
          className="mt-8 inline-block bg-forest px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-graphite"
          data-testid="notfound-home-link"
        >
          {t("notFound.cta")}
        </Link>
      </div>
    </div>
  );
};
